import React from 'react';
import { Lawyer } from '../../entity/entity.types';
import { LawyerList } from '../../entity/entity-lists/LawyerList';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
  ModalScrollableBody,
} from '../../components/modal';

type Props = {
  lawyers: Lawyer[];
  source: string;
  getEntityTitle: Function;
  getEntitySubtitle: Function;
  onRequestClose: () => void;
  isOpen: boolean;
};

export class AllOfficeLawyersModal extends React.Component<Props> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  render() {
    const {
      lawyers,
      onRequestClose,
      isOpen,
      getEntityTitle,
      getEntitySubtitle,
      source,
    } = this.props;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        <ModalScrollableHeader
          title="Avocats dans ce cabinet"
          onClose={onRequestClose}
        />
        <ModalScrollableContent>
          <ModalScrollableBody>
            <LawyerList
              lawyers={lawyers}
              source={`${source}_modal_list`}
              getEntityTitle={getEntityTitle}
              getEntitySubtitle={getEntitySubtitle}
              fromModal
            />
          </ModalScrollableBody>
        </ModalScrollableContent>
      </ModalScrollableContainer>
    );
  }
}
